/**
 * Legacy deep links used `/read#<id>` (or `/read#/<id>`). History-mode vue-router
 * only matches pathname, so we normalize the hash into `/read/:id`.
 */

export function parseLegacyReadHash(hash) {
  if (!hash || hash === '#') {
    return null;
  }

  const body = hash.replace(/^#/, '').replace(/^\//, '').trim();
  if (!/^\d+$/.test(body)) {
    return null;
  }

  return body;
}

/**
 * @param {import('vue-router').Route} route
 * @returns {import('vue-router').Location | null}
 */
export function legacyReadHashRedirect(route) {
  if (route.name !== 'read') {
    return null;
  }

  if (route.params.id) {
    return null;
  }

  const id = parseLegacyReadHash(window.location.hash);
  if (!id) {
    return null;
  }

  return {
    name: 'read',
    params: { id },
  };
}
